import { AudienceMode } from '../components/audiences/AudienceMode';
import Constants from '../constants';
import { NavigationActions } from '../store/NavigationActions';

const GoToAudienceDistributionOptions = (audienceId: number, surveyId: number, mode: AudienceMode) => {
	switch (mode) {
		case AudienceMode.Edit:
			return NavigationActions.Navigate(`/${surveyId}/audience/${audienceId}/distribution-options`);
		case AudienceMode.Admin:
			return NavigationActions.Navigate(Constants.ROUTE_SURVEY_ADMIN, surveyId, `audience/${audienceId}/distribution-options`);
	}
};

const GoToAudienceDetails = (surveyId: number, mode: AudienceMode, audienceId?: number) => {
	const withAudienceId = audienceId ? `/${audienceId}` : '';

	switch (mode) {
		case AudienceMode.Edit:
			return NavigationActions.Navigate(`/${surveyId}${Constants.ROUTE_AUDIENCE}${withAudienceId}`);
		case AudienceMode.Admin:
			return NavigationActions.Navigate(
				Constants.ROUTE_SURVEY_ADMIN,
				surveyId,
				`${Constants.SUBROUTE_SURVEY_ADMIN_AUDIENCE}/details${withAudienceId}`,
			);
	}
};

const GoToAudienceList = (surveyId: number, mode: AudienceMode) => {
	switch (mode) {
		case AudienceMode.Edit:
			return NavigationActions.Navigate(`/${surveyId}${Constants.ROUTE_AUDIENCES}`);
		case AudienceMode.Admin:
			return NavigationActions.Navigate(Constants.ROUTE_SURVEY_ADMIN, surveyId);
	}
};

const GoToAudienceMenu = (surveyId: number, audienceId: number) => {
	return NavigationActions.Navigate(Constants.ROUTE_SURVEY_ADMIN, surveyId, `${Constants.SUBROUTE_SURVEY_ADMIN_AUDIENCE}/${audienceId}`);
};

export const NavigationHelper = {
	GoToAudienceDetails,
	GoToAudienceDistributionOptions,
	GoToAudienceList,
	GoToAudienceMenu,
};
